export default {
  getCustomers: state => state.items,
}
